import masterData from "../masterData";

const contactParam = {};
//    console.log(asset);
const order = (a, b, prop) => {
  if (typeof prop == "function") {
    if (prop(a) < prop(b)) return -1;
    if (prop(a) > prop(b)) return 1;
  } else {
    if (a[prop] < b[prop]) return -1;
    if (a[prop] > b[prop]) return 1;
  }
  return 0;
};
const getSize = r => {
  return r.width * r.depth * r.height;
};
const getPrice = r => {
  return r.campaignPrice ? r.campaignPrice : r.price;
};

/* eslint-disable complexity */

export const searchRoom = (_rooms, condition, sort) => {
  console.log("rooms", _rooms, condition, sort);
  if (!_rooms) {
    return null;
  }

  let rooms = _rooms.filter(room => {
    if (condition.floor && condition.floor !== room.floor) {
      return false;
    }
    if (condition.vacant && !masterData.vacant.isContractable(room.vacant)) {
      return false;
    }
    if (condition.priceKey && condition.priceKey !== room.priceKey) {
      return false;
    }
    if (condition.extentKey && condition.extentKey !== room.extentKey) {
      return false;
    }
    if (condition.widthKey && condition.widthKey !== room.widthKey) {
      return false;
    }
    if (condition.heightKey && condition.heightKey !== room.heightKey) {
      return false;
    }
    if (condition.depthKey && condition.depthKey !== room.depthKey) {
      return false;
    }
    return true;
  });

  if (sort) {
    rooms = rooms.sort((a, b) => {
      return (a[sort.sortKey] - b[sort.sortKey]) * sort.sortDirection;
    });
  }
  return rooms;
};



// WEBPACK FOOTER //
// ./lib/masterUtil/searchRoom.js